module.exports = __webpack_public_path__ + "img/icon_14.88145461.jpg";